<div *ngIf="versionsList && !isLoading" class="page-container">
    <div class="sidebar-container">
        <app-versions-history-sidebar
            [urlState]="urlState"
            [vessel]="vessel"
            [versionsList]="versionsList"
            (onVersionSelected)="handleVersionSelected($event)"
            (onRestoreVersion)="restoreVersion($event)"></app-versions-history-sidebar>
    </div>
    <div class="version-changes-container">
        <app-version-changes
            [vessel]="vessel"
            [version]="selectedVersion"
            [previousVersion]="previousVersion"
            [firstVersion]="versionsList[versionsList.length - 2] ? versionsList[versionsList.length - 2] : undefined"
            [iApiShipyardId]="iApiShipyardId"
            (onRestoreVersion)="restoreVersion($event)"></app-version-changes>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
